import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';

import { AppRoutes } from './app/routes';
import { theme } from './app/themes';

import RequestNotificationPermission from '@components/pwa/RequestNotificationPermission';
import InstallPrompt from '@components/pwa/InstallPrompt';

export interface IAppProps {}

export const App: React.FC<IAppProps> = () => (
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <AppRoutes />
            <RequestNotificationPermission />
            <InstallPrompt />
        </BrowserRouter>
    </ThemeProvider>
);
